import { render, staticRenderFns } from "./table2019.vue?vue&type=template&id=568f19ec&scoped=true"
import script from "./table2019.vue?vue&type=script&lang=js"
export * from "./table2019.vue?vue&type=script&lang=js"
import style0 from "./table2019.vue?vue&type=style&index=0&id=568f19ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f19ec",
  null
  
)

export default component.exports